import { defineEvent } from '../types/event';
export var PRODUCT_IMAGE_CAROUSEL_UPDATE = defineEvent({
    platforms: [
        {
            name: 'Heap',
            transform: function (input) { return ({
                eventName: 'imageGallery_imagecarouselupdate',
                imageIndex: input.index,
                image: input.image
            }); }
        }
    ]
});
